import { useWatch } from 'react-hook-form';
import { round } from '../../../../../../../../helpers';
import { IOrderSale } from '../../order-sale-form';

// Live value of the sale's Devolución lines, IVA included. Each returned line is
// priced at the sale line's own prices and taxed at the sale's effective rate
// (tax / subtotal) — the same formula as the backend net totals
// (computeOrderSaleNetTotals), so `total` equals
// `total_with_tax − net_total_with_tax` once the sale is saved.
export function useReturnTotals(): {
    lineValues: number[];
    total: number;
    netTotalWithTax: number;
} {
    const [
        orderSaleProducts,
        orderAdjustmentProducts,
        subtotal,
        tax,
        totalWithTax,
    ] = useWatch({
        name: [
            'order_sale_products',
            'order_adjustment_products',
            'subtotal',
            'tax',
            'total_with_tax',
        ],
    }) as [
        IOrderSale['order_sale_products'] | undefined,
        IOrderSale['order_adjustment_products'],
        IOrderSale['subtotal'],
        IOrderSale['tax'],
        IOrderSale['total_with_tax'],
    ];

    const subtotalNumber = Number(subtotal) || 0;
    const taxMultiplier =
        subtotalNumber !== 0 ? 1 + (Number(tax) || 0) / subtotalNumber : 1;

    const lineValues = (orderAdjustmentProducts || []).map((oap) => {
        const line = (orderSaleProducts || []).find(
            (osp) => osp.product?.id === oap.product_id,
        );
        if (!line) return 0;
        return (
            (Number(oap.kilos) * Number(line.kilo_price) +
                Number(oap.groups) * Number(line.group_price)) *
            taxMultiplier
        );
    });

    const total = round(lineValues.reduce((acc, value) => acc + value, 0));

    return {
        lineValues: lineValues.map(round),
        total,
        netTotalWithTax: round((Number(totalWithTax) || 0) - total),
    };
}
